<template>
  <div>
    <div v-for="status in statuses">{{status}}</div>
  </div>
</template>

<script>
export default {
  props: ['statuses']
}
</script>



// WEBPACK FOOTER //
// LecturerStatus.vue?06561faa